export default __webpack_public_path__ + "static/media/2035.0d8f06c9.png";